'use client';

import React from 'react';
import { Dictionary } from '@/src/lib/dictionary/types.ts';
import Loading from '@/src/app/components/LoadingSpinner/LoadingSpinner.tsx';
import { useYourPriceContext } from '@/src/app/components/Providers/context/YourPriceContext.tsx';
import ProductInfoTableRow from '@/src/app/[country]/[lang]/shop/[...segments]/(product-details)/components/ProductInfoTable/ProductInfoTableRow.tsx';
import { formatDateClient } from '@/src/lib/date/business/format-date.client.ts';

function EstimatedShippingDate({ dict }: { dict: Dictionary }) {
  const { isLoading, yourPrice, error } = useYourPriceContext();

  if (isLoading) {
    return (
      <ProductInfoTableRow
        label={dict.product.estimatedShippingDate}
        value={
          <div className="h-3 inline-block">
            <Loading small />
          </div>
        }
        valueTestId="estimated-delivery-date"
      />
    );
  }

  if (error || !yourPrice?.items.length) {
    return (
      <ProductInfoTableRow
        label={dict.product.estimatedShippingDate}
        value={<span className="text-danger font-normal!">{dict.product.estimatedShippingDateError}</span>}
        valueTestId="estimated-delivery-date"
      />
    );
  }

  if (!yourPrice.items[0].estimatedShippingDate) {
    return null;
  }

  return (
    <ProductInfoTableRow
      label={dict.product.estimatedShippingDate}
      value={formatDateClient(yourPrice.items[0].estimatedShippingDate)}
      valueTestId="estimated-delivery-date"
    />
  );
}

export default EstimatedShippingDate;
